<template>
  <div class="app-content">
    <!-- 这里可以放其他布局内容，如导航、头部等 -->
    <router-view></router-view> <!-- 这是关键，确保子路由可以正确渲染 -->
  </div>
</template>

<script>
export default {
  name: 'MarketDynamics',
}
</script>
<style scoped>
  .app-content{
    height: 100%;
    width: 100%;
  }
</style>
